import FlameSVG from "@design-system/ui-icons/vanilla/Flame"
import { createIcon } from "../createIcon"

export const FlameIcon = createIcon(FlameSVG)
